import React from 'react';
import './applicationSettings.js'
import { ThemeProvider } from "@woodmac-hycb/theme-provider";
import { getTheme } from "@woodmac-hycb/theme-default";
import './custom.css';
import Home from './components/Home';
import AuthProviderHistory from './components/AuthProviderHistory';
import { ToggleRegionProvider } from "./hooks/useToggleRegion";


export default function App() {

  return (
    <ThemeProvider theme={getTheme()}>
      <AuthProviderHistory>
        <ToggleRegionProvider>
          <Home />
        </ToggleRegionProvider>
      </AuthProviderHistory>
    </ThemeProvider>
  );
}
